module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-plugin",
    attrs: {
      "id": "order-plugin"
    }
  }, [(!_vm.loading && !_vm.error) ? _c('div', [_c('router-view')], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', [_vm._v("\n        Zur Zeit kann diese Seite nicht vollständig geladen werden. Bitte versuche es später noch einmal.\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2421faaa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/App.vue
// module id = 874
// module chunks = 0